import React, { useState, useRef } from 'react';

const SimpleWebcamTest = () => {
  const [webcamStream, setWebcamStream] = useState(null);
  const [error, setError] = useState('');
  const videoRef = useRef(null);

  const startWebcam = async () => {
    try {
      setError('');
      console.log('Requesting webcam access...');
      
      const stream = await navigator.mediaDevices.getUserMedia({
        video: true,
        audio: false
      });
      
      console.log('Webcam access granted');
      setWebcamStream(stream);
      
      if (videoRef.current) {
        videoRef.current.srcObject = stream;
        await videoRef.current.play();
        console.log('Video playing');
      }
    } catch (err) {
      console.error('Error accessing webcam:', err);
      setError(`Error accessing webcam: ${err.message || err.toString()}`);
    }
  };

  const stopWebcam = () => {
    if (webcamStream) {
      webcamStream.getTracks().forEach(track => track.stop());
      setWebcamStream(null);
    }
  };

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <h1>Simple Webcam Test</h1>
      
      <div style={{ marginBottom: '20px' }}>
        <button 
          onClick={startWebcam}
          disabled={!!webcamStream}
          style={{
            padding: '10px 20px',
            fontSize: '16px',
            backgroundColor: '#28a745',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: webcamStream ? 'not-allowed' : 'pointer',
            marginRight: '10px'
          }}
        >
          Start Webcam
        </button>
        
        <button 
          onClick={stopWebcam}
          disabled={!webcamStream}
          style={{
            padding: '10px 20px',
            fontSize: '16px',
            backgroundColor: '#dc3545',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: webcamStream ? 'pointer' : 'not-allowed'
          }}
        >
          Stop Webcam
        </button>
      </div>
      
      {error && (
        <div style={{ 
          color: 'red', 
          marginBottom: '20px',
          padding: '10px',
          backgroundColor: '#f8d7da',
          border: '1px solid #f5c6cb',
          borderRadius: '4px'
        }}>
          <strong>Error:</strong> {error}
        </div>
      )}
      
      {webcamStream ? (
        <div>
          <video
            ref={videoRef}
            autoPlay
            playsInline
            style={{
              width: '100%',
              maxWidth: '640px',
              border: '2px solid #007bff',
              borderRadius: '4px'
            }}
          />
          <p style={{ marginTop: '10px', color: '#6c757d' }}>
            If you can see yourself, the webcam is working correctly.
          </p>
        </div>
      ) : (
        <div style={{ 
          width: '100%', 
          maxWidth: '640px', 
          height: '480px',
          border: '2px dashed #ccc',
          borderRadius: '4px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#6c757d'
        }}>
          Webcam feed will appear here
        </div>
      )}
      
      <div style={{ marginTop: '20px', padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '4px' }}>
        <h3>Troubleshooting Tips:</h3>
        <ul>
          <li>Make sure you have a webcam connected to your computer</li>
          <li>Check that your browser has permission to access the camera</li>
          <li>If using Chrome, check site permissions in Settings &gt; Privacy and security &gt; Site Settings &gt; Camera</li>
          <li>Try refreshing the page if the webcam doesn't start</li>
          <li>If you're using HTTPS, make sure the certificate is valid</li>
        </ul>
      </div>
    </div>
  );
};

export default SimpleWebcamTest;